import { LocalTrack, RemoteParticipant } from "twilio-video"
import { create } from "zustand"
import { devtools } from "zustand/middleware"

export interface IVideoCallState {
  localTracks: LocalTrack[]
  participants: RemoteParticipant[]
}

export interface IVideoCallActions {
  setLocalTracks: (localTracks: LocalTrack[]) => void
  setParticipants: (participant: RemoteParticipant[]) => void
}

const initialState: IVideoCallState = {
  localTracks: [],
  participants: [],
}

const useVideoCallStore = create<IVideoCallState & IVideoCallActions>()(
  devtools(
    (set) => ({
      ...initialState,
      setLocalTracks: (localTracks) => set({ localTracks }),
      setParticipants: (participants) => set({ participants }),
    }),
    { name: "videoCall" },
  ),
)

export default useVideoCallStore
